
import { defineComponent, PropType, computed } from 'vue'

import { DateTime } from 'luxon'

import { UtcOffsetDisplay } from '../util'

import { Artist, Store } from '../types'

export default defineComponent({
  name: 'ArtistListItem',
  props: {
    timezone: {
      type: String,
      default: '',
    },
    emitter: {
      type: Object,
      required: true,
    },
    store: {
      type: Object as PropType<Store>,
      required: true,
    },
    artist: {
      type: Object as PropType<Artist>,
      required: true,
    },
  },
  setup(props) {
    const availableFromTime = computed(() => {
      const dt = DateTime.fromISO(props.artist.available[0].from, { zone: 'UTC' })
      const redt = dt.setZone(props.timezone)
      return redt.toFormat('HH:mm')
    })

    const availableToTime = computed(() => {
      const dt = DateTime.fromISO(props.artist.available[0].to, { zone: 'UTC' })
      const redt = dt.setZone(props.timezone)
      return redt.toFormat('HH:mm')
    })

    return {
      props,
      UtcOffsetDisplay,
      availableFromTime,
      availableToTime,
    }
  },
})
